import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const assessmentFormativeCreate: ApiFunc<`${typeof API.ASSESSMENT_FORMATIVE}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_FORMATIVE, data)

export const assessmentFormativeList: ApiFunc<`${typeof API.ASSESSMENT_FORMATIVE}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_FORMATIVE, {
    params: data,
  })
